import React from "react";
import { Box, Text, VStack, Progress } from "@chakra-ui/react";

const TrustScoreDisplay = ({ trustScore }) => {
  const badgeColor = trustScore >= 90 ? "green.500" : trustScore >= 70 ? "yellow.400" : "red.400";

  return (
    <Box>
      <VStack align="start" spacing={2}>
        <Text fontWeight="bold">Trust Score:</Text>
        <Progress value={trustScore} colorScheme="blue" size="lg" />
        <Text color={badgeColor} fontWeight="bold">
          {trustScore}% {trustScore >= 90 ? "Trusted Partner" : ""}
        </Text>
      </VStack>
    </Box>
  );
};

export default TrustScoreDisplay;
